import styled from "styled-components"

export const AccountWrap = styled.div`
    padding: 15px;

    @media screen and (max-width: 767px) {
        padding: 12px 0;
    }
`
export const InfoDetail = styled.div``

export const AccountTitle = styled.p`
    color: #222;
    font-size: 14px;
    font-weight: bold;
    margin: 20px 0;
`
